<div class="modal-overlay" (click)="close()">
  <div class="admin-modal" style="width: 900px;" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3 class="modal-title">{{ mode === 'edit' ? 'Edit' : 'New' }} JCD KEY</h3>
      <div class="header-actions">
        <i class="fa" [ngClass]="{'fa-plus-square-o': jcdModalMinimise, 'fa-minus-square-o': !jcdModalMinimise}"
           style="margin-right: 10px; cursor: pointer;" [title]="jcdModalMinimise ? 'Maximize' : 'Minimize'" (click)="jcdModalMinimise = !jcdModalMinimise"></i>
        <i class="fa fa-times" style="cursor: pointer;" title="Close" (click)="close()"></i>
      </div>
    </div>
    <div class="modal-body" [hidden]="jcdModalMinimise">
      <div class="row row-gray-callOut">
        <div class="row" style="margin: 10px 5px 0 5px;">
          <div class="col-md-2">
            <label>Client: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Select Client" direction="top"></i></label>
            <select class="form-control" [(ngModel)]="jcdModalClient" [ngModelOptions]="{standalone: true}" (ngModelChange)="onJcdModalClientChange()">
              @for (c of jcdModalClientList; track $index) {
<option [ngValue]="c">{{ c.client_name }}</option>
}
            </select>
          </div>
          <div class="col-md-2">
            <label>App Key <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Select App Key (Channel)" direction="top"></i></label>
            <select class="form-control" [(ngModel)]="jcdModalChannel" [ngModelOptions]="{standalone: true}">
              @for (ch of jcdModalChannelList; track $index) {
<option [ngValue]="ch">{{ ch.channel_name }}</option>
}
            </select>
          </div>
          <div class="col-sm-1" style="padding-left: 0;">
            @if (jcdModalChannelLoading) {
<div class="gt-filter-loading" style="margin-top: 30px; width: 140px;">
              <i class="fa fa-spinner fa-spin"></i>
            </div>
}
          </div>
          <div class="col-md-2">
            <label>&nbsp;</label>
            <div>
              <i style="font-size: 24px; margin-top: 5px; cursor: pointer;" class="fa fa-plus-circle color-green"
                 ap-tooltip [appendAfterTarget]="true" tooltipContent="Create New Channel" direction="top" (click)="jcdModalShowNewChannel = !jcdModalShowNewChannel"></i>
            </div>
          </div>
        </div>
      </div>

      @if (jcdModalShowNewChannel) {
<div class="panel panel-default" style="margin-top: 10px;">
        <div class="panel-heading"><h4 style="margin: 0;">Add New Channel</h4></div>
        <div class="panel-body">
          <div class="row">
            <div class="col-md-2">
              <label>Client: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Client for new channel" direction="top"></i></label>
              <select class="form-control" [(ngModel)]="jcdNewChannelForm.client" [ngModelOptions]="{standalone: true}">
                @for (c of jcdModalClientList; track $index) {
<option [ngValue]="c">{{ c.client_name }}</option>
}
              </select>
            </div>
            <div class="col-md-2">
              <label>Channel Name: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Unique channel name" direction="top"></i></label>
              <input type="text" class="form-control" maxlength="50" placeholder="enter Channel name"
                [(ngModel)]="jcdNewChannelForm.channel_name" [ngModelOptions]="{standalone: true}">
            </div>
            <div class="col-md-3">
              <label>Channel Desc: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Channel description" direction="top"></i></label>
              <textarea class="form-control" placeholder="enter channel desc" maxlength="2000"
                [(ngModel)]="jcdNewChannelForm.channel_desc" [ngModelOptions]="{standalone: true}"></textarea>
            </div>
            <div class="col-md-2">
              <label>Channel Priority: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Channel priority number" direction="top"></i></label>
              <input type="number" class="form-control" placeholder="enter priority"
                [(ngModel)]="jcdNewChannelForm.channel_priority" [ngModelOptions]="{standalone: true}">
            </div>
            <div class="col-md-2">
              <label>Channel Status: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Active or Inactive" direction="top"></i></label>
              <select class="form-control" [(ngModel)]="jcdNewChannelForm.channel_status" [ngModelOptions]="{standalone: true}">
                @for (s of channelStatusList; track $index) {
<option [ngValue]="s.value">{{ s.name }}</option>
}
              </select>
            </div>
          </div>
        </div>
        <div class="panel-footer">
          <button class="btn btn-primary btn-sm" type="button" (click)="saveJcdModalChannel()">Save</button>
          <button class="btn btn-info btn-sm" type="button" (click)="jcdModalShowNewChannel = false">Cancel</button>
        </div>
      </div>
}
    </div>
    <div class="modal-footer" [hidden]="jcdModalMinimise">
      <button class="btn btn-primary btn-sm" type="button" (click)="saveNewJCD()" [disabled]="!jcdModalChannel">save</button>
      <button class="btn btn-info btn-sm" type="button" (click)="close()">Cancel</button>
      <button class="btn btn-info btn-sm" type="button" (click)="clearJcdModalForm()">Clear Form</button>
    </div>
  </div>
</div>
